<div class="event-log-toolbox" [id]="'log-box-toolbox'+log.id">
  <div class="event-log-toolbox-tool tooltip-content" *ngIf="isHasEventVideo(log) && !isLoading && !isOnlyShowDetail" [id]="'download-toolbox-'+log.id+'-box'" (mouseenter)="setTooltipPosition($event, 'download-toolbox-'+log.id)" (click)="download($event, log)"><i class="material-icons-outlined" style="font-size: 20px">download</i>
    <div class="tooltip" [id]="'download-toolbox-'+log.id">
      <div class="tooltip-content-box">Download</div>
    </div>
  </div>
  <div class="event-log-toolbox-tool loading" *ngIf="isLoading">
    <div class="loader">
      <div class="tooltip" [id]="'download-toolbox-'+log.id">
        <div class="tooltip-content-box"></div>
      </div>
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
      </svg>
    </div>
  </div>
  <div class="event-log-toolbox-tool tooltip-content" *ngIf="isHasEventVideo(log) && !isOnlyShowDetail" [id]="'shared-link-toolbox-'+log.id+'-box'" (mouseenter)="setTooltipPosition($event, 'shared-link-toolbox-'+log.id)" (click)="openDownloadLinkModal($event, log)"><i class="material-icons-outlined" style="font-size: 20px">ios_share</i>
    <div class="tooltip" [id]="'shared-link-toolbox-'+log.id">
      <div class="tooltip-content-box">Share Download Link</div>
    </div>
  </div>
  <div class="event-log-toolbox-tool" (click)="showActionMenus($event, log)"><i class="material-icons-outlined" style="font-size: 20px">more_vert</i>
    <div class="action-menus" [id]="'action-menus'+log.id" [class.visible]="log.isShowMenu">
      <ng-container *ngIf="isHasEventVideo(log)">
        <div class="action-menus-box" (click)="openVideoEventViewer(log)">View Video</div>
      </ng-container>
      <div class="action-menus-box" (click)="openLogDetail(log)">Show info</div>
      <div class="action-menus-box" *ngIf="isHasEventVideo(log) && !isOnlyShowDetail" (click)="openDownloadLinkModal($event, log)">Share Download Link</div>
    </div>
  </div>
</div>